// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dzCIk","top":"styles_top__1l0BX","left":"styles_left__18zRV","description":"styles_description__VLb9-"};